import { getGlobalEventsLogs, IEvent, createConsumer, createSubscriber } from '@cian/events-log';
import * as React from 'react';

export const useFeedbackForm = () => {
  let feedbackTimeout: number;
  const requestFeedbackForm = () => {
    const globalLog = getGlobalEventsLogs();

    globalLog.produce('feedback', { type: 'open', value: true });
    feedbackTimeout = window.setTimeout(() => {
      window.location.href = '/contacts/';
    }, 50);
  };

  React.useEffect(() => {
    const feedbackConsumer = createConsumer({ topic: 'feedback' });

    const feedbackSubscriber = createSubscriber((event: IEvent<unknown>) => {
      if (event.type === 'popup_opened') {
        window.clearTimeout(feedbackTimeout);
      }
    });

    feedbackConsumer.subscribe(feedbackSubscriber);

    return () => {
      feedbackConsumer.unsubscribe(feedbackSubscriber);
      feedbackConsumer.destroy();
      window.clearTimeout(feedbackTimeout);
    };
  });

  return { requestFeedbackForm };
};
